export default function DisciplineIcon({ naziv_tipa }) {
  const first = naziv_tipa ? naziv_tipa.substring(0, 1).toUpperCase() : '';
  const isExclusion = naziv_tipa?.includes(' iz ');

  return (
    <div className="icon-container" style={isExclusion ? { backgroundColor: '#cc0000' } : {}}>
      <div className="icon-style">{first}</div>
    </div>
  );
}
